import {
  Box,
  BoxProps,
  DEVICE_ICON_MATCH,
} from '@amzn/ring-ui-react-components';
import { Icon } from 'src/shared/components/Icon';

export interface DeviceSelectorDropdownIconProps
  extends Pick<BoxProps, 'm' | 'mb' | 'mt' | 'mr' | 'ml'> {
  type: string;
  size: number;
}
export const DeviceSelectorDropdownIcon = ({
  size,
  type,
  ...props
}: DeviceSelectorDropdownIconProps) => {
  const DeviceIcon = DEVICE_ICON_MATCH[type];
  return (
    <Box mb={1} mr={2} {...props}>
      {DeviceIcon ? (
        <DeviceIcon width={`${size}px`} height={`${size}px`} />
      ) : (
        <Icon name="camera" size={size} />
      )}
    </Box>
  );
};
